import { render, staticRenderFns } from "./BiddingAdditionalLinks.vue?vue&type=template&id=275e683e&scoped=true&"
import script from "./BiddingAdditionalLinks.vue?vue&type=script&lang=js&"
export * from "./BiddingAdditionalLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e683e",
  null
  
)

export default component.exports